import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @file Trigger 触发器
 */
import { Emitter } from '@tencent/glue-util-emitter';
import { getDefaultElementBoundary } from '@tencent/glue-util-boundary';
import { getElementBoundary, isFixed } from '@tencent/glue-dom-boundary';
import { guid } from '@tencent/glue-util-helper';
export var Trigger = /*#__PURE__*/function (_Emitter) {
  _inherits(Trigger, _Emitter);

  var _super = _createSuper(Trigger);

  function Trigger(popper, triggerType, triggerGroup, id) {
    var _this;

    _classCallCheck(this, Trigger);

    _this = _super.call(this);
    _this.triggerType = 'manual';
    _this.disabled = false;
    _this.data = null;
    _this.reference = null;
    _this.rect = getDefaultElementBoundary();
    _this.activeShow = false;
    _this.disposed = false;
    _this.disableToggleClose = false;
    _this.id = id || guid();
    _this.triggerType = triggerType;
    _this.popper = popper;
    _this.triggerGroup = triggerGroup;

    _this.popper.registerTrigger(_assertThisInitialized(_this));

    if (_this.triggerGroup) {
      _this.triggerGroup.registerTrigger(_assertThisInitialized(_this));
    }

    return _this;
  }

  _createClass(Trigger, [{
    key: "updateReference",
    value: function updateReference(reference) {
      this.reference = reference;
    }
  }, {
    key: "updateTriggerOptions",
    value: function updateTriggerOptions(options) {
      var _options$disabled = options.disabled,
          disabled = _options$disabled === void 0 ? false : _options$disabled,
          _options$data = options.data,
          data = _options$data === void 0 ? null : _options$data,
          _options$disableToggl = options.disableToggleClose,
          disableToggleClose = _options$disableToggl === void 0 ? false : _options$disableToggl;
      this.disabled = disabled;
      this.data = data;
      this.disableToggleClose = disableToggleClose;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.disposed) {
        return;
      }

      this.popper.unregisterTrigger(this);

      if (this.triggerGroup) {
        this.triggerGroup.unregisterTrigger(this);
      }

      this.disposed = true;
    }
  }, {
    key: "isTriggerFixed",
    value: function isTriggerFixed() {
      var ref = this.getReference();

      if (ref == null) {
        return false;
      }

      return isFixed(ref);
    }
  }, {
    key: "updateRect",
    value: function updateRect(rect) {
      this.rect = rect;
      this.popper.updateRefRect(this.id);
    }
  }, {
    key: "getRect",
    value: function getRect() {
      // 如果在不监控trigger位置的时候获取rect，手动获取一次
      if (!this.isFocus() && !this.isActiveShow()) {
        this.rect = this.reference ? getElementBoundary(this.reference) : this.rect;
      }

      return this.rect;
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "getDisableToggleClose",
    value: function getDisableToggleClose() {
      return this.disableToggleClose;
    }
  }, {
    key: "showPopper",
    value: function showPopper() {
      if (this.disabled) {
        return;
      }

      if (this.triggerGroup) {
        this.triggerGroup.setActiveTrigger(this.id);
      }

      this.popper.showPopper(this.id);
    }
  }, {
    key: "hidePopper",
    value: function hidePopper() {
      if (this.disabled) {
        return;
      }

      if (this.triggerGroup && this.id === this.triggerGroup.getActiveTrigger()) {
        this.triggerGroup.cancelActiveTrigger(this.id);
        this.popper.hidePopper(this.id);
      } else {
        this.popper.hidePopper(this.id);
      }
    }
  }, {
    key: "setActiveShow",
    value: function setActiveShow(show) {
      this.activeShow = show;
      this.emit('update-active', this.activeShow);
    }
  }, {
    key: "isActiveShow",
    value: function isActiveShow() {
      return this.activeShow;
    }
  }, {
    key: "isFocus",
    value: function isFocus() {
      return this.popper.isTriggerFocus(this.id);
    }
  }, {
    key: "isGroup",
    value: function isGroup() {
      return false;
    }
  }, {
    key: "getTriggerIdPath",
    value: function getTriggerIdPath() {
      var res = [this.id];

      if (!this.triggerGroup) {
        return res;
      }

      return this.triggerGroup.getTriggerIdPath().concat(res);
    }
  }, {
    key: "getTriggerType",
    value: function getTriggerType() {
      return this.triggerType;
    }
  }, {
    key: "getReference",
    value: function getReference() {
      return this.reference;
    }
  }]);

  return Trigger;
}(Emitter);